export default __webpack_public_path__ + "static/media/checkers-1-rMAX.da7a8ccd.jpg";